import * as yup from 'yup';
import { manualTransferFormFields } from '../../fields/formFields';

export const manualTransferFormSchema = yup.object({
  [manualTransferFormFields.transferTo]: yup.string().oneOf(['ANB', 'ALPACA']).required('"Transfer To" is required'),
  [manualTransferFormFields.amount]: yup.number().min(1, 'Amount must be at least 1').required('Amount is required'),
});
